import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { eInventoryRouteNames } from '../enums/route-names';

export const INVENTORY_ROUTE_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService],
    multi: true,
  },
];

export function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/inventory',
        name: eInventoryRouteNames.Inventory,
        iconClass: 'fas fa-boxes',
        layout: eLayoutType.application,
        order: 3,
      },
      {
        path: '/inventory/Administration',
        parentName: eInventoryRouteNames.Inventory,
        name: eInventoryRouteNames.InventoryAdmin,
        iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
    ]);
  };
}
